import { render, staticRenderFns } from "./FacilitatorClosingSlide.vue?vue&type=template&id=5777c828&scoped=true"
import script from "./FacilitatorClosingSlide.vue?vue&type=script&lang=js"
export * from "./FacilitatorClosingSlide.vue?vue&type=script&lang=js"
import style0 from "./FacilitatorClosingSlide.vue?vue&type=style&index=0&id=5777c828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777c828",
  null
  
)

export default component.exports